// Native mobile bootstrapping — runs only when the app is inside a Capacitor shell.
// Safe no-op on the web build.

export async function initNativeShell() {
  if (typeof window === "undefined") return;
  const isNative = !!window?.Capacitor?.isNativePlatform?.();
  if (!isNative) return;

  try {
    const { SplashScreen } = await import(/* webpackIgnore: true */ "@capacitor/splash-screen");
    setTimeout(() => SplashScreen.hide().catch(() => {}), 500);
  } catch {}

  try {
    const { StatusBar, Style } = await import(/* webpackIgnore: true */ "@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark }).catch(() => {});
    await StatusBar.setBackgroundColor({ color: "#061224" }).catch(() => {});
  } catch {}

  try {
    const { PushNotifications } = await import(/* webpackIgnore: true */ "@capacitor/push-notifications");
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive === "granted") {
      await PushNotifications.register();
      PushNotifications.addListener("registration", (token) => {
        try {
          // Register the device token with the backend so we can push to this driver
          fetch(`${process.env.REACT_APP_BACKEND_URL}/api/devices/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ token: token.value, platform: window.Capacitor.getPlatform?.() || "unknown" }),
          }).catch(() => {});
        } catch {}
      });
      PushNotifications.addListener("pushNotificationReceived", (n) => {
        console.log("Push received:", n);
      });
    }
  } catch {}
}
